<div class="arrivals-board">

	<!-- Header -->
	<div class="board-header">
		<div class="board-title">
			<h2>Arrivals Agent <small class="text-muted">— day-of arrival board</small></h2>
		</div>
	</div>

	<!-- Date navigation bar -->
	<div class="date-nav-bar">

		<!-- Date picker with prev/next -->
		<div class="date-picker-row">
			<button pButton icon="pi pi-chevron-left" class="p-button-text p-button-sm nav-arrow"
					(click)="prevDay()" title="Previous day"></button>
			<input type="date" class="date-input" [value]="selectedDate"
				   (change)="onDateInputChange($any($event.target).value)" />
			<span class="date-display">{{ selectedDateDisplay }}</span>
			<button pButton icon="pi pi-chevron-right" class="p-button-text p-button-sm nav-arrow"
					(click)="nextDay()" title="Next day"></button>
			<button pButton label="Today" class="p-button-sm p-button-outlined today-btn"
					(click)="goToToday()" [disabled]="isToday"></button>
		</div>

		<!-- Quick-link buttons: Arrivals / Departures × Yesterday / Today / Tomorrow -->
		<div class="quick-links">
			<span class="quick-group-label">Arrivals:</span>
			<button class="quick-link" [class.active]="isActiveNav('arrivals', -1)" (click)="quickNav('arrivals', -1)">Yesterday</button>
			<button class="quick-link" [class.active]="isActiveNav('arrivals',  0)" (click)="quickNav('arrivals',  0)">Today</button>
			<button class="quick-link" [class.active]="isActiveNav('arrivals',  1)" (click)="quickNav('arrivals',  1)">Tomorrow</button>

			<span class="quick-divider">|</span>

			<span class="quick-group-label">Departures:</span>
			<button class="quick-link" [class.active]="isActiveNav('departures', -1)" (click)="quickNav('departures', -1)">Yesterday</button>
			<button class="quick-link" [class.active]="isActiveNav('departures',  0)" (click)="quickNav('departures',  0)">Today</button>
			<button class="quick-link" [class.active]="isActiveNav('departures',  1)" (click)="quickNav('departures',  1)">Tomorrow</button>

			<button pButton icon="pi pi-refresh" class="p-button-text p-button-sm ml-3"
					(click)="loadBoard()" title="Refresh" [loading]="loading"></button>
		</div>

	</div>

	<!-- Location filter chips -->
	<div class="location-filter-bar">
		<span class="filter-label">Location:</span>
		<button *ngFor="let opt of locationFilterOptions"
				class="location-chip-btn"
				[class.active]="locationFilter === opt.id"
				(click)="setLocationFilter(opt.id)">
			{{ opt.label }}
		</button>
	</div>

	<!-- Board table -->
	<p-table [value]="filteredRows" [loading]="loading" [paginator]="true" [rows]="50"
			 [rowsPerPageOptions]="[25,50,100,200]" [totalRecords]="filteredRows.length"
			 sortMode="multiple" styleClass="p-datatable-striped p-datatable-sm"
			 [globalFilterFields]="['guestLastName','reservationId','propertyCode']">

		<ng-template pTemplate="caption">
			<div class="table-caption">
				<span class="result-count">
					{{ filteredRows.length }} {{ viewType === 'departures' ? 'departure' : 'arrival' }}{{ filteredRows.length !== 1 ? 's' : '' }}
					for {{ selectedDateDisplay }}
					<ng-container *ngIf="locationFilter !== null"> — {{ locationChip(locationFilter).name }} only</ng-container>
				</span>
			</div>
		</ng-template>

		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="locationId" style="width:8rem">
					Location <p-sortIcon field="locationId"></p-sortIcon>
				</th>
				<th pSortableColumn="propertyCode">Property <p-sortIcon field="propertyCode"></p-sortIcon></th>
				<th pSortableColumn="occupancyStatusName" style="width:11rem">
					Room Status <p-sortIcon field="occupancyStatusName"></p-sortIcon>
				</th>
				<th pSortableColumn="guestLastName">Guest <p-sortIcon field="guestLastName"></p-sortIcon></th>
				<th pSortableColumn="reservationStatus" style="width:7rem">Status <p-sortIcon field="reservationStatus"></p-sortIcon></th>
				<th style="width:4rem">Party</th>
				<th pSortableColumn="checkInDateTime" style="width:7rem">
					Check-In <p-sortIcon field="checkInDateTime"></p-sortIcon>
				</th>
				<th pSortableColumn="checkOutDateTime" style="width:7rem">
					Check-Out <p-sortIcon field="checkOutDateTime"></p-sortIcon>
				</th>
				<th style="width:4rem; text-align:center">Door</th>
				<th class="lifecycle-col">Lifecycle</th>
				<th style="width:9rem">Actions</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-row>
			<tr [ngStyle]="{'border-left': '5px solid ' + roomStatusChip(row.occupancyStatus).color}">

				<!-- Location -->
				<td>
					<span class="location-chip"
						  [ngStyle]="{'background': locationChip(row.locationId).bg}">
						{{ locationChip(row.locationId).name }}
					</span>
				</td>

				<!-- Property -->
				<td>
					<a [routerLink]="['/property-edit', row.shortTermRentalId]" target="_blank" class="board-link">
						<b>{{ row.propertyCode || '—' }}</b>
					</a>
					<div *ngIf="row.propertyName" class="prop-name-sub">{{ row.propertyName }}</div>
				</td>

				<!-- Room Status — click to override -->
				<td>
					<span class="status-chip status-chip-clickable"
						  [ngStyle]="{'background': roomStatusChip(row.occupancyStatus).color}"
						  (click)="openRoomStatusDialog(row)"
						  title="Click to override room status">
						{{ roomStatusChip(row.occupancyStatus).name }}
						<i class="pi pi-pencil status-edit-icon"></i>
					</span>
				</td>

				<!-- Guest -->
				<td>
					<a [routerLink]="['/reservations', row.reservationId]" target="_blank" class="board-link">
						{{ row.guestFirstName }} {{ row.guestLastName }}
					</a>
					<div *ngIf="!row.guestFirstName && !row.guestLastName" class="text-muted">—</div>
					<div *ngIf="row.guestMobile || row.primaryMobilePhone" class="guest-mobile">
						{{ row.guestMobile || row.primaryMobilePhone }}
					</div>
				</td>

				<!-- Reservation status chip -->
				<td>
					<span class="res-type-chip"
						  [ngStyle]="{'background': resStatusChip(row.reservationStatus).color,
						              'color': resStatusChip(row.reservationStatus).textColor}">
						{{ resStatusChip(row.reservationStatus).name }}
					</span>
				</td>

				<!-- Party size -->
				<td style="text-align:center">{{ row.partySize || '—' }}</td>

				<!-- Check-in. Render in UTC: checkInDateTime is a date-only value
				     stored at midnight, so its UTC date is the true calendar date.
				     Without the explicit 'UTC' the pipe uses the viewer's browser
				     timezone and shows the date one day early (a 05/28 check-in
				     rendered as 05/27). -->
				<td>{{ row.checkInDateTime | date:'MM/dd EEE':'UTC' }}</td>

				<!-- Check-out (UTC for the same reason — see check-in note). -->
				<td>{{ row.checkOutDateTime | date:'MM/dd EEE':'UTC' }}</td>

				<!-- Door code status — click to view/edit -->
				<td style="text-align:center; cursor:pointer" (click)="openDoorDialog(row)" title="View or edit door code">
					<span *ngIf="row.doorCodeValid"  class="door-ok pi pi-check-circle"             title="Door code valid — click to edit"></span>
					<span *ngIf="!row.doorCodeValid" class="door-missing pi pi-exclamation-triangle" title="Door code missing — click to add"></span>
				</td>

				<!-- Lifecycle dots -->
				<td class="lifecycle-cell">
					<span class="lifecycle-dot"
						  *ngFor="let s of stages"
						  [ngClass]="dotStatus(row, s.code)"
						  [attr.data-group]="s.group"
						  [attr.data-trigger]="s.triggerType"
						  [title]="dotTitle(row, s)"
						  (click)="openPreview(row, s.code)">
						<span class="dot-label">{{ s.short }}</span>
					</span>
				</td>

				<!-- Actions -->
				<td style="white-space:nowrap">
					<button pButton label="Preview / Send" class="p-button-sm p-button-outlined"
							(click)="openPreview(row)"></button>
					<button pButton icon="pi pi-refresh" class="p-button-sm p-button-outlined ml-1"
							pTooltip="Re-run backfill for this unit now"
							[loading]="!!refreshing[row.shortTermRentalId]"
							(click)="refreshUnit(row)"></button>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="11" style="text-align:center; padding:2rem; color:#888">
					<i class="pi pi-inbox" style="font-size:1.5rem; display:block; margin-bottom:.5rem"></i>
					No {{ viewType }} found for {{ selectedDateDisplay }}.
				</td>
			</tr>
		</ng-template>

	</p-table>
</div>

<!-- Preview / Send dialog -->
<p-dialog [(visible)]="previewOpen" [modal]="true" styleClass="arrivals-preview-dialog"
		  [style]="{width:'92vw','max-width':'92vw'}" [contentStyle]="{minWidth:'900px'}"
		  header="Arrival Text Preview" (onHide)="closePreview()">

	<div *ngIf="selectedReservation">

		<!-- Reservation summary -->
		<div class="preview-res-header">
			<span class="preview-prop">{{ selectedReservation.propertyCode || '—' }}</span>
			<span class="preview-guest"> &middot; {{ selectedReservation.guestFirstName }} {{ selectedReservation.guestLastName }}</span>
			<span class="preview-resid text-muted"> &middot; res #{{ selectedReservation.reservationId }}</span>
		</div>

		<!-- Stage selector -->
		<div class="preview-stage-row">
			<label class="me-2">Stage:</label>
			<select class="form-select form-select-sm d-inline-block w-auto"
					[(ngModel)]="selectedStageCode" (change)="stageChanged(selectedStageCode)">
				<option *ngFor="let s of stages" [ngValue]="s.code">{{ s.label }}</option>
			</select>
		</div>

		<!-- Loading -->
		<div *ngIf="previewLoading" class="preview-loading">
			<i class="pi pi-spin pi-spinner"></i> Loading preview...
		</div>

		<!-- Error -->
		<div *ngIf="!previewLoading && previewError" class="alert alert-danger mt-2">
			{{ previewError }}
		</div>

		<!-- Body -->
		<div *ngIf="!previewLoading && !previewError">
			<div *ngIf="previewAlreadySent" class="alert alert-info mt-2">
				This stage has already been sent for this reservation.
			</div>
			<div *ngIf="selectedStageCode === 5 && !previewDoorCodeValid" class="alert alert-warning mt-2">
				Door code is invalid or missing — Ready-for-Check-In may be suppressed.
				Override allowed, but confirm the code is correct before sending.
			</div>
			<pre class="preview-body">{{ previewBody }}</pre>
		</div>

	</div>

	<p-footer>
		<button pButton label="Close" class="p-button-text" (click)="closePreview()"></button>
		<button pButton label="Send Now" icon="pi pi-send"
				(click)="confirmSend()"
				[disabled]="previewLoading || !!previewError"></button>
	</p-footer>

</p-dialog>

<!-- Room Status Override dialog -->
<p-dialog [(visible)]="roomStatusDialogOpen" [modal]="true" [style]="{width:'420px'}"
          [header]="'Override Room Status — ' + (roomStatusDialogRow?.propertyCode || '')"
          (onHide)="closeRoomStatusDialog()">

    <div class="p-fluid" *ngIf="roomStatusDialogRow">
        <p class="text-muted" style="font-size:0.85rem; margin-bottom:1rem">
            Current: <strong>{{ roomStatusChip(roomStatusDialogRow.occupancyStatus).name }}</strong>
        </p>
        <div class="p-field">
            <label style="font-weight:600; font-size:0.85rem; display:block; margin-bottom:0.6rem">Select new status</label>
            <div style="display:flex; flex-wrap:wrap; gap:0.5rem; margin-top:0.25rem">
                <div *ngFor="let opt of roomStatusOptions"
                     (click)="roomStatusDialogValue = opt.code"
                     [ngStyle]="{
                         'background':    opt.color,
                         'color':         '#fff',
                         'padding':       '0.35rem 0.9rem',
                         'border-radius': '999px',
                         'font-size':     '0.82rem',
                         'font-weight':   '600',
                         'cursor':        'pointer',
                         'border':        roomStatusDialogValue === opt.code ? '3px solid #1b3a5c' : '3px solid transparent',
                         'box-shadow':    roomStatusDialogValue === opt.code ? '0 0 0 2px #1b3a5c' : 'none',
                         'text-shadow':   '0 1px 2px rgba(0,0,0,0.3)',
                         'user-select':   'none',
                         'min-width':     '8rem',
                         'text-align':    'center',
                         'transition':    'border 0.12s, box-shadow 0.12s'
                     }">
                    {{ opt.name }}
                </div>
            </div>
        </div>
        <div *ngIf="roomStatusDialogError" class="alert alert-danger mt-2">{{ roomStatusDialogError }}</div>
    </div>

    <p-footer>
        <button pButton label="Cancel" class="p-button-text" (click)="closeRoomStatusDialog()"></button>
        <button pButton label="Save Status" icon="pi pi-save"
                [loading]="roomStatusDialogSaving"
                [disabled]="roomStatusDialogValue == null"
                (click)="saveRoomStatus()"></button>
    </p-footer>
</p-dialog>

<!-- Door Code dialog -->
<p-dialog [(visible)]="doorDialogOpen" [modal]="true" [style]="{width:'400px'}"
          [header]="'Door Code — ' + (doorDialogRow?.propertyCode || '')"
          (onHide)="closeDoorDialog()">

    <div *ngIf="doorDialogLoading" style="text-align:center; padding:1rem">
        <i class="pi pi-spin pi-spinner"></i> Loading...
    </div>

    <div *ngIf="!doorDialogLoading">
        <div class="p-fluid">
            <div class="p-field">
                <label for="doorCodeInput">
                    {{ doorAccessCodeId ? 'Update door code' : 'No code on file — enter new code' }}
                </label>
                <input id="doorCodeInput" type="text" pInputText
                       [(ngModel)]="doorCodeValue"
                       placeholder="e.g. 1234 or #1234#"
                       [style]="{marginTop:'0.5rem', fontSize:'1.25rem', letterSpacing:'0.15em'}" />
            </div>
        </div>
        <div *ngIf="doorDialogError" class="alert alert-danger mt-2">{{ doorDialogError }}</div>
    </div>

    <p-footer>
        <button pButton label="Cancel" class="p-button-text" (click)="closeDoorDialog()"></button>
        <button pButton label="Save Code" icon="pi pi-save"
                [loading]="doorDialogSaving"
                [disabled]="doorDialogLoading || !doorCodeValue?.trim()"
                (click)="saveDoorCode()"></button>
    </p-footer>
</p-dialog>
